import { useState, useEffect } from "react";

// Detect if device is mobile
export const useDeviceType = () => {
    // Initialize with a function to avoid hydration issues and initial Desktop flash
    const [deviceType, setDeviceType] = useState(() => {
        // Return Desktop for SSR, will be corrected on client
        if (typeof window === 'undefined') return "Desktop";
        return window.innerWidth < 768 ? "Mobile" : "Desktop";
    });
    
    useEffect(() => {
        const handleResize = () => {
            let detectedType = window.innerWidth < 768 ? "Mobile" : "Desktop";
            // if (/Android|webOS|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)) {
            //     detectedType = "Mobile";
            // }
            console.log("useDeviceType - handleResize, window.innerWidth : ", window.innerWidth, "detectedType:", detectedType, "current deviceType:", deviceType);
            if (detectedType !== deviceType) {
                setDeviceType(detectedType);
            }
        }
        
        // Call handleResize immediately to set correct initial value
        handleResize();
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [deviceType]);
    
    return deviceType;
};
